import { TCreateCategoryAction, CreateCategoryActionTypes } from './createCategoryActions';
import { ICreateCategoryState } from './createCategoryContext';

export const createCategoryReducer = (
	state: ICreateCategoryState,
	action: TCreateCategoryAction,
): ICreateCategoryState => {
	switch (action.type) {
		case CreateCategoryActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case CreateCategoryActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
				fetchedRestaurants: [],
			};
		case CreateCategoryActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
			};
		case CreateCategoryActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case CreateCategoryActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case CreateCategoryActionTypes.CHANGE_NAME_OF_CATEGORY:
			return {
				...state,
				nameOfCategory: action.payload.nameOfCategory,
			};
		case CreateCategoryActionTypes.SET_CATEGORY_TYPE:
			return {
				...state,
				categoryType: action.payload.categoryType,
			};
		case CreateCategoryActionTypes.TOGGLE_IS_RESTRICTED:
			return {
				...state,
				isRestricted: !state.isRestricted,
			};
		case CreateCategoryActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY:
			return {
				...state,
				hasSchedulePriority: !state.hasSchedulePriority,
			};
		case CreateCategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case CreateCategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case CreateCategoryActionTypes.SET_FETCHED_TRANSLATIONS:
			return {
				...state,
				translations: action.payload.translations,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case CreateCategoryActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case CreateCategoryActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case CreateCategoryActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateCategoryActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				fetchedCustomers: [],
				IDSelectedCustomer: null,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				nameOfCategory: '',
				categoryType: null,
				isRestricted: false,
				hasSchedulePriority: false,
				activationSchedule: '',
				deactivationSchedule: '',
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
